module.exports = __webpack_public_path__ + "img/hero.7b1db8fa.svg";